import Gradient1 from "../../styles/illustrations/gradients/gradient_1.png";
import { Typography } from "../ui/Typography/Typography";
import "./ActionPlanActivity.scss";

interface ActivityHeaderProps {
  title?: string;
  description?: string;
}

export const ActivityHeader = ({ title, description }: ActivityHeaderProps) => {
  return (
    <div className="ActivityHeader">
      <div className="ActivityHeader__title">
        <img src={Gradient1} alt="" />
        <Typography desktop="h3">{title}</Typography>
      </div>
      {description && <Typography desktop="body1">{description}</Typography>}
    </div>
  );
};
